<div class="sp-min-height__full sp-width__full sp-background__accent sp-position__relative">
  <app-plain-toolbar></app-plain-toolbar>

  <div class="sp-page__with-toolbar sp-row sp-padding__top-x4 sp-padding__bottom-x4">
    <app-auth-mfa-form class="sp-margin__auto sp-width__full-md"></app-auth-mfa-form>
  </div>
</div>
